import React from 'react';
import { Control } from 'react-hook-form';

import classes from './PricingForm.module.scss';
import { CreateSubscriptionFormValues } from '../../../../../interfaces/createSubscription';
import { MonthlyRenewalPaymentDetail } from '../../../../../interfaces/entitySubscription';
import { InputGroup } from '../../../components/InputGroup/InputGroup';
import { LbNumericFormatInput } from '../../../../../../shared/components/form-components';
import { validateMinimalPrice } from '../../../utils/validateMinimalPrice';
import { getPriceView } from '../../../../../../shared/utils/stringUtils';
import { PaymentDetailsCell } from '../../../components/PaymentDetailsCell/PaymentDetailsCell';

type OneTimePaymentPricingFormProps = {
  control: Control<CreateSubscriptionFormValues>;
  title: string;
  description: string;
  paymentDetails: MonthlyRenewalPaymentDetail | null;
  isLoadingPaymentDetails?: boolean;
};

const PricingForm = ({
  control,
  title,
  description,
  paymentDetails,
  isLoadingPaymentDetails,
}: OneTimePaymentPricingFormProps) => {
  return (
    <InputGroup title={title} description={description}>
      <div className={classes.inputBox}>
        <LbNumericFormatInput
          control={control}
          name="subscriptionPrice.monthlyRenewalPrice"
          label="Price"
          variant="outlined"
          size="small"
          helperText={`The minimum price is ${getPriceView(paymentDetails?.minMonthlyRenewalPrice.value)}`}
          rules={{
            required: 'Price is required',
            validate: (value) =>
              validateMinimalPrice(value, paymentDetails?.minMonthlyRenewalPrice),
          }}
          prefix="$"
          allowNegative={false}
          decimalScale={2}
          fixedDecimalScale={true}
          selectValueOnFocus={true}
        />
        <div className={classes.paymentDetailsBox}>
          <PaymentDetailsCell
            paymentDetail={paymentDetails?.stripeFees}
            isLoading={isLoadingPaymentDetails}
            showDivider
          />
          <PaymentDetailsCell
            paymentDetail={paymentDetails?.entityDeposit}
            isLoading={isLoadingPaymentDetails}
          />
        </div>
      </div>
    </InputGroup>
  );
};

export { PricingForm };
